import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import _ from "lodash";

class Comment extends Component {

  constructor(props) {
    super(props);

    if (props.details.length === 0) {
      props.onDetailsUpdated([{microTime: getCurrentMicroTime(props.startTime)}]);
    }
  }

  validate() {
    let validate =  {
      valid: true,
      errors: []
    };

    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render() {
    return (
      <React.Fragment/>
    )
  }
}

Comment.propTypes = {
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    microTime: PropTypes.number,
  }).isRequired),
  changePage: PropTypes.func.isRequired,
  question: PropTypes.shape({
    content: PropTypes.string.isRequired,
  }).isRequired,
  validationTexts: PropTypes.shape({

  }).isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Comment);